import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Grid,
  useMediaQuery,
  useTheme,
  Box,
  Button,
  Typography,
} from "@material-ui/core";
import { useLocation } from "react-router-dom";
// DIDIT INTEGRATION - COMMENTED OUT
// import { useAppSelector } from "../../../redux/typedHooks";
// import { UserInterface } from "../../../types/user";
import SearchPanel from "./Search-panel/search-panel";
import CreatorPost, {
  CreatorPostRef,
} from "../Sidebar/MyFeed-explore/creator-post";
import CreatorSuggestions from "./SuggestionsCreators/suggestions-creators";
import ArrowsSort from "../../../assets/ArrowsSort";
// DIDIT INTEGRATION - COMMENTED OUT
// import VerificationGuard from "../../elements/VerificationGuard";
import useBaseStyle from "../../../styles/baseStyle";
import { getCategoriesAPI } from "../../../api/categoriesApi";
import GuideSteps, { GuideStep } from "../../elements/GuideSteps";

import { useHistory } from "react-router-dom";
import useSEO from "../../../seo/use-seo";
import "../../../assets/style/homepage.css";
import { useAppSelector } from "../../../redux/typedHooks";
import { UserInterface } from "../../../types/user";
import { useFeedEngagement } from "../../../hooks/useFeedEngagement";
import { isSearchIndexingBlocked } from "../../../config/searchIndexing";
import StandardPageHelmet from "../../../seo/components/StandardPageHelmet";
import { buildHomePageJsonLd } from "../../../seo/jsonLd/buildHomePageJsonLd";

const HomePage = () => {
  const seo = useSEO("home");
  const homeJsonLd = useMemo(() => {
    if (isSearchIndexingBlocked()) return null;
    if (typeof window === "undefined") return null;
    return buildHomePageJsonLd(
      window.location.origin,
      seo.title,
      seo.description
    );
  }, [seo.title, seo.description]);
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const user = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );
  const userRole = user?.userType?.title?.toLowerCase?.() || "guest";
  const [visionType, setVisionType] = useState<string>(() => {
    if (typeof window === "undefined") {
      return "Explore";
    }
    const params = new URLSearchParams(window.location.search);
    const vt = params.get("visionType");
    if (vt === "Explore" || vt === "My Subscription") {
      return vt;
    }
    if (vt === "My Feed") {
      return "My Subscription";
    }
    return "Explore";
  });
  useFeedEngagement(visionType, user?.id, userRole);
  const [showSuggestions, setShowSuggestions] = useState<boolean>(() => {
    // Завантажуємо налаштування з localStorage
    const saved = localStorage.getItem("showSuggestions");
    return saved !== null ? JSON.parse(saved) : true; // За замовчуванням показуємо
  });
  const [openFilterModal, setOpenFilterModal] = useState<(() => void) | null>(
    null
  );
  const [pendingFilter, setPendingFilter] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const initialSortBy = (() => {
    // Спочатку перевіряємо URL параметри
    const urlSortBy = searchParams.get("sortBy");
    if (urlSortBy === "recent" || urlSortBy === "popular") {
      return urlSortBy as "popular" | "recent";
    }
    // Потім перевіряємо localStorage
    const savedSortBy = localStorage.getItem("sortBy");
    if (savedSortBy === "recent" || savedSortBy === "popular") {
      return savedSortBy as "popular" | "recent";
    }
    // За замовчуванням
    return "popular";
  })();
  const [sortBy, setSortBy] = useState<"popular" | "recent">(initialSortBy);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [categories, setCategories] = useState<
    Array<{ _id: string; name: string; description: string }>
  >([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(
    () => {
      if (typeof window === "undefined") return null;
      const params = new URLSearchParams(window.location.search);
      return params.get("categoryId");
    }
  );
  const classes = useBaseStyle();
  const mobileFilterButtonRef = useRef<HTMLButtonElement>(null);
  const mobileDropdownRef = useRef<HTMLDivElement>(null);
  const creatorPostRef = useRef<CreatorPostRef>(null);
  const searchPanelRef = useRef<HTMLDivElement>(null);
  const categoriesRef = useRef<HTMLDivElement>(null);
  const firstPostUsernameRef = useRef<any>(null);

  // Guide steps для home page (тільки крок 1)
  const homeGuideSteps: GuideStep[] = [
    {
      id: 1,
      title: "Welcome to Sugar Cribs!",
      description:
        "Discover user profiles and start engaging with their content",
      targetRef: firstPostUsernameRef, // Використовуємо ref замість selector
      position: "bottom",
      offset: { x: 200, y: 20 },
    },
    {} as any,
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const vt = params.get("visionType");
    if (vt === "Explore" || vt === "My Subscription") {
      setVisionType(vt);
    } else if (vt === "My Feed") {
      // Backward compatibility for old URLs: map My Feed to My Subscription
      setVisionType("My Subscription");
    }
    const categoryFromUrl = params.get("categoryId");
    setSelectedCategoryId(categoryFromUrl || null);
  }, [location.search]);

  // Load categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategoriesAPI();
        if (response.success && response.data) {
          setCategories(response.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const updateVisionType = (type: string) => {
    const params = new URLSearchParams(location.search);
    params.set("visionType", type);
    history.push({ pathname: location.pathname, search: params.toString() });
  };

  const toggleSuggestions = () => {
    const newState = !showSuggestions;
    setShowSuggestions(newState);
    // // Зберігаємо налаштування в localStorage
    localStorage.setItem("showSuggestions", JSON.stringify(newState));
    // if (!newState) {
    //   setPendingFilter(false);
    //   setOpenFilterModal(null);
    // }
  };

  const updateSortBy = (value: "popular" | "recent") => {
    setSortBy(value);
    setIsFilterOpen(false);

    // Зберігаємо вибір в localStorage
    localStorage.setItem("sortBy", value);

    const params = new URLSearchParams(location.search);
    params.set("sortBy", value);
    history.push(`?${params.toString()}`);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isFilterOpen &&
        mobileDropdownRef.current &&
        mobileFilterButtonRef.current &&
        !mobileDropdownRef.current.contains(event.target as Node) &&
        !mobileFilterButtonRef.current.contains(event.target as Node)
      ) {
        setIsFilterOpen(false);
      }
    };

    if (isFilterOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterOpen]);

  // useEffect(() => {
  //   if (pendingFilter && openFilterModal) {
  //     openFilterModal();
  //     setPendingFilter(false);
  //   }
  // }, [pendingFilter, openFilterModal]);

  return (
    // DIDIT INTEGRATION - COMMENTED OUT
    // <VerificationGuard
    //   userId={user?.id || ""}
    //   skipVerification={!user?.id} // Skip verification if no user
    //   userRoles={user?.userType?.title ? [user.userType.title] : []} // Pass user roles
    // >
    <>
      <StandardPageHelmet seo={seo} jsonLd={homeJsonLd} />
      <div className={classes.root}>
        <div
          style={{
            maxWidth: 1110,
            margin: "0 auto",
            padding: isMobile ? "0 15px" : "0",
          }}
        >
          <div
            className={classes.searchPanelContainer}
            ref={searchPanelRef}
            data-guide-step="search-panel"
          >
            <SearchPanel
              visionType={visionType}
              setVisionType={updateVisionType}
              showSuggestions={showSuggestions}
              toggleSuggestions={toggleSuggestions}
              onToggleSuggestions={toggleSuggestions}
              onPostCreated={() => {
                // Refresh feed after post creation
                if (creatorPostRef.current) {
                  creatorPostRef.current.refreshFeed();
                }
              }}
            />
          </div>

          {/* Categories Section */}
          {visionType === "Explore" && categories.length > 0 && (
            <div
              ref={categoriesRef}
              data-guide-step="categories"
              style={{
                marginBottom: isMobile ? "16px" : "24px",
                display: "flex",
                alignItems: "center",
                flexWrap: isMobile ? "nowrap" : "wrap",
                gap: "12px",
                overflowX: isMobile ? "auto" : "visible",
                overflowY: "hidden",
              }}
            >
              {!isMobile && (
                <Typography
                  style={{
                    color: "#FFFFFF",
                    fontSize: "24px",
                    fontWeight: 700,
                    marginRight: "8px",
                  }}
                >
                  Discover categories:
                </Typography>
              )}
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexWrap: isMobile ? "nowrap" : "wrap",
                  marginLeft: isMobile ? "0" : "auto",
                  minWidth: isMobile ? "max-content" : "auto",
                }}
              >
                {categories.map(category => (
                  <Button
                    key={category._id}
                    className="category-button"
                    disableRipple
                    onClick={() => {
                      const nextId =
                        selectedCategoryId === category._id
                          ? null
                          : category._id;
                      setSelectedCategoryId(nextId);
                      const params = new URLSearchParams(location.search);
                      if (nextId) {
                        params.set("categoryId", nextId);
                      } else {
                        params.delete("categoryId");
                      }
                      history.push({
                        pathname: location.pathname,
                        search: params.toString(),
                      });
                    }}
                    style={{
                      backgroundColor:
                        selectedCategoryId === category._id
                          ? "#FF78AA1A"
                          : "#FFFFFF0D",
                      color: "#FFFFFF",
                      padding: "6px 16px",
                      borderRadius: "6px",
                      fontSize: isMobile ? "14px" : "20px",
                      fontWeight: 400,
                      textTransform: "none",
                      border:
                        selectedCategoryId === category._id
                          ? "1px solid #EF599680"
                          : "1px solid #FFFFFF0D",
                      cursor: "pointer",
                      transition: "border-color 0.3s ease",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    {category.name}
                  </Button>
                ))}
              </Box>
            </div>
          )}

          {/* Mobile Popular Button - after categories */}
          {isMobile && (
            <Box
              display="flex"
              alignItems="center"
              marginBottom={2}
              style={{ gap: 12, position: "relative" }}
            >
              <Button
                ref={mobileFilterButtonRef}
                onClick={() => setIsFilterOpen(prev => !prev)}
                style={{
                  borderRadius: 8,
                  color: "#FFFFFF",
                  padding: "8px 12px",
                  textTransform: "none",
                  justifyContent: "center",
                  fontSize: 14,
                  position: "relative",
                  width: "auto",
                }}
              >
                <div
                  style={{
                    marginRight: "8px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <ArrowsSort />
                </div>
                <div style={{ marginRight: "4px" }}>
                  <b>
                    {sortBy === "popular"
                      ? "Popular"
                      : sortBy === "recent"
                        ? "Newest"
                        : "Filter"}
                  </b>{" "}
                </div>
                <span style={{ fontSize: 12 }}>first</span>
              </Button>

              {isFilterOpen && (
                <div
                  ref={mobileDropdownRef}
                  style={{
                    position: "absolute",
                    background: "#111",
                    borderRadius: "6px",
                    marginTop: "6px",
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column",
                    top: 44,
                    left: 0,
                    width: "110px",
                    backgroundColor: "#2A2A2A",
                    padding: "8px",
                    gap: "4px",
                  }}
                >
                  <div
                    onClick={() => updateSortBy("popular")}
                    style={{
                      backgroundColor: "#FFFFFF08",
                      border: "none",
                      padding: "8px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#FFFFFF",
                    }}
                  >
                    Popular
                  </div>
                  <div
                    onClick={() => updateSortBy("recent")}
                    style={{
                      backgroundColor: "#FFFFFF08",
                      border: "none",
                      padding: "8px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#FFFFFF",
                    }}
                  >
                    Newest
                  </div>
                </div>
              )}
            </Box>
          )}

          <Grid
            container
            className={classes.container}
            spacing={isMobile ? 2 : 0}
          >
            <Grid
              item
              xs={12}
              md={showSuggestions ? 8 : 12}
              style={!isMobile ? { maxWidth: 580 } : undefined}
            >
              <div style={{ width: "100%" }}>
                <CreatorPost
                  ref={creatorPostRef}
                  visionType={visionType}
                  selectedCategoryId={selectedCategoryId}
                  firstPostUsernameRef={firstPostUsernameRef}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4} className={classes.CreatorSuggestions}>
              {showSuggestions && (
                <CreatorSuggestions
                  onToggleVisibility={toggleSuggestions}
                  registerOpenFilter={setOpenFilterModal}
                />
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <GuideSteps steps={homeGuideSteps} pageType="home" stepOffset={1} />
    </>
    // DIDIT INTEGRATION - COMMENTED OUT
    // </VerificationGuard>
  );
};

export default HomePage;
